import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
function DateInput({ label, onChange }) {
  const [date, setDate] = useState("");
  const persianDate = date
    ? new DateObject(new Date(date)).convert(persian, persian_fa)
    : null;

  return (
    <div className="admin-date-input flex flex-col w-full">
      <label className="block mb-2 text-sm font-medium text-slate-700 dark:text-slate-200">
        {label || ""}
      </label>
      <DatePicker
        format="YYYY/MM/DD HH:mm:ss"
        value={persianDate}
        onChange={(selected) => {
          const nextDate = selected ? selected.toDate().toISOString() : "";
          setDate(nextDate);
          onChange(nextDate);
        }}
        calendar={persian}
        inputClass="admin-field w-full"
        locale={persian_fa}
        calendarPosition="bottom-right"
        plugins={[
          <TimePicker position="bottom" hStep={2} mStep={3} sStep={4} />,
        ]}
      />
    </div>
  );
}

export default DateInput;
